<template>
  <div id="advanced-search" class="content-container flex-row">
    <!-- Filter Bar -->
    <div class="sidebar white left fixed" :class="sidebarVisibleClass">
      <form action="javascript:;" @submit.prevent="search()" style="width: 100%;">
      <div class="fixed-container">
        <a href="javascript:;" @click="toggleSidebar" class="sidebar-minimized-button">
          <span class="button-arrow"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-small"></use></svg></span>
          <span class="glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-filter"></use></svg></span>
        </a>

        <TheLoader v-if="loaded < 5" :small="true" :active="true"/>
        <template v-else>

          <overlay-scrollbars :options="{ className: 'sidebar-content-container small-padding custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
            <div class="small-form-grid">
              <div class="grid-x grid-padding-x">
                <div class="cell">
                  <h4>Filter</h4>
                </div>

                <div class="cell">
                  <label for="filter-auksjon">Kunstner</label>
                  <b-taginput
                    v-model="selectedFilters.kunstner"
                    :data="filteredKunstner"
                    autocomplete
                    :allow-new="false"
                    :open-on-focus="true"
                    field="val"
                    icon="label"
                    :placeholder="!selectedFilters.kunstner || selectedFilters.kunstner.length < 1 ? 'Velg kunstner…' : ''"
                    @typing="getFilteredKunstnerDebounced"
                    @add="onKunstnerAdd"
                    @remove="onKunstnerDel"
                    ref="kunstnerSelector"
                    size="is-small"
                    attached
                    :loading="kunstnerSearching"
                  >
                    <template slot-scope="props">
                      <span v-if="props.option.val">
                        {{ props.option.val }}<span v-if="props.option.period">, {{ props.option.period }}</span>
                      </span>
                      <span v-else>
                        {{ props.option.key }}<span v-if="props.option.period">, {{ props.option.period }}</span>
                      </span>
                      <!-- {{ props.option.key }}<span v-if="props.option.val">, {{ props.option.val }}</span> -->
                    </template>
                    <template #empty>
                      Fant ingen kunstner…
                    </template>
                  </b-taginput>
                </div>

                <div class="cell">
                  <label>Kategori</label>
                  <b-taginput
                    v-model="selectedFilters.kategori"
                    :data="filteredKategori"
                    autocomplete
                    :allow-new="false"
                    :open-on-focus="true"
                    field="key"
                    icon="label"
                    :placeholder="!selectedFilters.kategori || selectedFilters.kategori.length < 1 ? 'Velg kategori…' : ''"
                    @typing="getFilteredKategori"
                    size="is-small"
                    attached
                    class="uppercase"
                  >
                    <template slot-scope="props">
                      {{ props.option.val }}
                    </template>
                    <template #empty>
                      Fant ingen kategori…
                    </template>
                  </b-taginput>
                </div>

                <div class="cell">
                  <label for="filter-auksjon">Auksjon</label>
                  <b-taginput
                    v-model="selectedFilters.auksjon"
                    :data="filteredAuksjon"
                    autocomplete
                    :allow-new="false"
                    :open-on-focus="true"
                    field="key"
                    icon="label"
                    :placeholder="!selectedFilters.auksjon || selectedFilters.auksjon.length < 1 ? 'Velg auksjon…' : ''"
                    @typing="getFilteredAuksjonDebounced"
                    @add="onAuctionAdd"
                    @remove="onAuctionDel"
                    ref="auctionSelector"
                    size="is-small"
                    attached
                    :loading="auctionSearching"
                  >
                    <template slot-scope="props">
                      {{ props.option.key }}<span v-if="props.option.val">, {{ props.option.val }}</span>
                    </template>
                    <template #empty>
                      Fant ingen auksjon…
                    </template>
                  </b-taginput>
                </div>

                <TheSwitchInput v-model="selectedFilters.auksjonSearchAll" containerClassName="cell" :small="true" labelTrue="Søk også i den forrige auksjonen" labelFalse="Søk også i den forrige auksjonen" :trueValue="true" :falseValue="false"/>
              </div>
            </div>

            <div class="small-form-grid">
              <div class="grid-x grid-padding-x">
                <div class="cell large-6">
                  <label for="price_from">Vurdering fra</label>
                  <div class="input-container currency symbol-glyph" data-symbol="kr">
                    <input type="text" v-model="selectedFilters.price.from" id="price_from">
                  </div>
                </div>

                <div class="cell large-6">
                  <label for="price_to">Vurdering til</label>
                  <div class="input-container currency symbol-glyph" data-symbol="kr">
                    <input type="text" v-model="selectedFilters.price.to" id="price_to">
                  </div>
                </div>
              </div>
            </div>

            <div class="small-form-grid">
              <div class="grid-x grid-padding-x">
                <div class="cell">
                  <label>Avdeling</label>
                  <b-taginput
                    v-model="selectedFilters.avdeling"
                    :data="filteredAvdeling"
                    autocomplete
                    :allow-new="false"
                    :open-on-focus="true"
                    field="val"
                    icon="label"
                    :placeholder="!selectedFilters.avdeling || selectedFilters.avdeling.length < 1 ? 'Velg avdeling…' : ''"
                    @typing="getFilteredAvdeling"
                    size="is-small"
                    attached
                  >
                    <template slot-scope="props">
                      {{ props.option.val }}
                    </template>
                    <template #empty>
                      Fant ingen avdeling…
                    </template>
                  </b-taginput>
                </div>

                <div class="cell">
                  <label>Kontrakttype</label>
                  <b-taginput
                    v-model="selectedFilters.objekttype"
                    :data="filteredObjekttype"
                    autocomplete
                    :allow-new="false"
                    :open-on-focus="true"
                    field="key"
                    icon="label"
                    :placeholder="!selectedFilters.objekttype || selectedFilters.objekttype.length < 1 ? 'Velg kontrakttype…' : ''"
                    @typing="getFilteredObjekttype"
                    size="is-small"
                    attached
                  >
                    <template slot-scope="props">
                      {{ props.option.key }}<span v-if="props.option.val">, {{ props.option.val}}</span>
                    </template>
                    <template #empty>
                      Fant ingen objekttype…
                    </template>
                  </b-taginput>
                </div>

                <div class="cell">
                  <label>Lokasjon</label>
                  <b-taginput
                    v-model="selectedFilters.lokasjon"
                    :data="filteredLokasjon"
                    autocomplete
                    :allow-new="false"
                    :open-on-focus="true"
                    field="val"
                    icon="label"
                    :placeholder="!selectedFilters.lokasjon || selectedFilters.lokasjon.length < 1 ? 'Velg lokasjon…' : ''"
                    @typing="getFilteredLokasjon"
                    size="is-small"
                    attached
                  >
                    <template slot-scope="props">
                      {{ props.option.val }}
                    </template>
                    <template #empty>
                      Fant ingen lokasjon…
                    </template>
                  </b-taginput>
                </div>
              </div>
            </div>

            <div class="small-form-grid">
              <div class="grid-x grid-padding-x">
                <div class="cell">
                  <label for="date_from">Registrert dato fra</label>
                  <div class="input-container date dropdown-top">
                    <b-datepicker
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      :max-date="selectedFilters.regdato.to || null"
                      v-model="selectedFilters.regdato.from"
                      placeholder="Vis kalender..."
                      icon="glyph-input-date"
                      ref="date_from"
                      id="date_from">
                      <button type="button" class="button disabled" v-if="!selectedFilters.regdato.from" @click.prevent="$refs.date_from.toggle()"><span>Slett dato</span></button>
                      <button type="button" class="button" v-else @click.prevent="selectedFilters.regdato.from = null"><span>Slett dato</span></button>
                    </b-datepicker>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                  </div>
                </div>

                <div class="cell">
                  <label for="date_to">Registrert dato til</label>
                  <div class="input-container date dropdown-top">
                    <b-datepicker
                      :show-week-number="false"
                      :editable="false"
                      :first-day-of-week="1"
                      :min-date="selectedFilters.regdato.from || null"
                      v-model="selectedFilters.regdato.to"
                      placeholder="Vis kalender..."
                      icon="calendar-today"
                      ref="date_to"
                      id="date_to">
                      <button type="button" class="button disabled" v-if="!selectedFilters.regdato.to" @click.prevent="$refs.date_to.toggle()"><span>Slett dato</span></button>
                      <button type="button" class="button" v-else @click.prevent="selectedFilters.regdato.to = null"><span>Slett dato</span></button>
                    </b-datepicker>
                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                  </div>
                </div>
              </div>
            </div>
          </overlay-scrollbars>

          <div class="grid-x toolbar footer large-padding">
            <div class="grid-x">
              <div class="cell auto">
                <a href="javascript:;" @click="onResetFilter()" class="button primary transparent">Tilbakestill filter</a>
              </div>
              <div class="cell shrink">
                <button v-if="!loading" href="javascript:;" type="submit" class="button submit primary" @click="search()"><span class="button-title">Søk</span></button>
                <button v-else href="javascript:;" type="submit" class="button submit primary loading"><span class="button-title">Søk</span> <span class="loader-spinner"></span></button>
              </div>
            </div>
          </div>
        </template>
      </div>

      </form>
    </div>
    <!-- // Filter Bar -->

    <!-- Result Content -->
    <div class="content-container flex-row">
      <div class="content-container flex-column">
        <div class="content-container gray flex-row content-x-scroll content-y-scroll table-results">
          <!-- Pagination -->
          <div class="pagination-loader-container sidebar-padding">
            <div class="pagination-loader">
              <span class="results">Viser <strong>{{list.length | thousands}}</strong> av {{hits | thousands}} treff</span>

              <a href="javascript:;" v-if="loading" class="button primary tiny loading">Last flere <span class="loader-spinner"></span></a>
              <a href="javascript:;" v-else-if="list.length < 1" class="button primary tiny disabled">Last flere</a>
              <a href="javascript:;" v-else-if="list.length < hits" @click="more()" class="button primary tiny">Last flere</a>
              <a href="javascript:;" v-else-if="list.length >= hits" class="button primary tiny disabled">Last flere</a>

              <a href="javascript:;" @click="scrollToTop()" title="Scroll til toppen" class="button tiny scrolltop"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
            </div>
          </div>
          <!-- // Pagination -->

          <!-- Popover -->
          <template v-if="objektPopoverItem">
            <span id="objekt-popover" class="has-popover popover align-x-left align-y-bottom xlarge hover-card-popover">
              <ul>
                <li><a href="javascript:;" @click="loadObjektModal(objektPopoverItem.Objektid)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg> <span>Vis objekt</span></a></li>
                <li><a :href="objektPopoverItem.kontraktLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis kontrakt</span></a></li>
                <li v-if="objektPopoverItem.mottaker"><a :href="objektPopoverItem.kjoperLink" target="_blank"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis Kjøper</span></a></li>
                <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis Kjøper</span></a></li>
                <li><a :href="objektPopoverItem.kundeLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis selger</span></a></li>
                <li v-if="objektPopoverItem.Kunstner"><a @click="openKunstnerObjektListModal(objektPopoverItem.kunstner)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg> <span>Kunstnerens objekter</span></a></li>
              </ul>
              <div class="hover-card">
                <div class="data-grid">
                  <div class="grid-x grid-padding-x grid-padding-small active">
                    <div class="cell border-bottom hover-card-header">
                      <span class="thumbnail medium">
                        <img :src="objektPopoverItem.Photo" alt="">
                      </span>

                      <span class="hover-card-content">
                        <span class="item-title">
                          <span class="title data-hc-title">{{objektPopoverItem.title}}</span>
                          <span class="subtitle data-hc-subtitle">{{objektPopoverItem.Objektnr}}</span>
                          <span class="subtitle data-hc-count">Antall: {{objektPopoverItem.Antall || '-'}}</span>
                        </span>
                      </span>
                    </div>

                    <div class="cell large-6 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Lav vurdering</span>
                        <span class="dl dd data-hc-price-low">{{objektPopoverItem.Vurderingspris2 | thousands}}</span>
                      </div>
                    </div>

                    <div class="cell large-6 border-bottom">
                      <div class="dl-wrap">
                        <span class="dl dt">Høy vurdering</span>
                        <span class="dl dd data-hc-price-high">{{objektPopoverItem.Vurderingspris1 | thousands}}</span>
                      </div>
                    </div>

                    <div class="cell large-6">
                      <div class="dl-wrap">
                        <span class="dl dt">Minstepris</span>
                        <span class="dl dd data-hc-price-min">{{objektPopoverItem.Minstepris | thousands}}</span>
                      </div>
                    </div>

                    <div class="cell large-6">
                      <div class="dl-wrap">
                        <span class="dl dt">Tilslag</span>
                        <span class="dl dd data-hc-sold">{{objektPopoverItem.Salgspris | thousands}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </template>
          <!-- // End popover -->

          <table class="large fixed sortable clickable sticky-table-header compressed" :class="[selectedImageSize.key || 'c-image-small']" id="table-thumbnails" style="height: 0">
            <thead>
              <tr class="header">
                <th class="c-number sorttable_numeric">#</th>
                <th class="c-options unsortable">&nbsp;</th>
                <th v-for="(col, index) in columns" :key="col.key + '_' + index" class="handle" :class="col.class" @click="sortColumn(col, index)">
                  {{col.name}}
                  <span id="sorttable_sortfwdind" v-if="sort === col.sortKey && dir === 'ASC'" class="sort-on">&nbsp;</span>
                  <span id="sorttable_sortrevind" v-else-if="sort === col.sortKey && dir === 'DESC'" class="sort-on">&nbsp;</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, trindex) in list" :key="trindex">
                <td class="c-number sorttable_numeric">{{trindex + 1}}</td>
                <td class="c-options unsortable" @click="toggleObjektInfo($event, row.Objektid)"><a href="javascript:;"><span></span></a></td>
                <template v-for="(col, tdindex) in row.row">
                  <td @click="openObjekt(row.Objektid)" v-if="col.image" :key="trindex + '.' + tdindex" :class="col.class">
                    <img v-if="selectedImageSize.key !== 'c-image-none'" :class="{'hi-trigger': col.large}" :src="col.value" :data-hi-src-full="col.large" data-hi-size="large" />
                  </td>
                  <td @click="openObjekt(row.Objektid)" v-else-if="col.tooltip" :key="trindex + '.' + tdindex" :class="col.class" v-tippy :content="col.tooltip">{{col.value}}</td>
                  <td @click="openObjekt(row.Objektid)" v-else :key="trindex + '.' + tdindex" :class="col.class" >{{col.value}}</td>
                </template>
              </tr>
              <template v-if="searchDone">
                <tr v-if="list.length < 1"><td colspan="30" style="text-align: left;">Fant ingen objekter...</td></tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- // Result Content -->
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'
import AuksjonService from '@/services/AuksjonService'
import KunstnerService from '@/services/KunstnerService'
import NodeService from '@/services/NodeService'
import moment from 'moment'
import bus from '@/plugins/event-bus'
import Vue from 'vue'
import VueTippy from 'vue-tippy'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

Vue.use(VueTippy, {
  directive: 'tippy',
  duration: 0,
  delay: 0,
  followCursor: false,
  arrow: true,
  animateFill: false,
  interactive: false,
  allowHTML: true,
  animation: 'fade',
  // offset: '50,0',
  placement: 'left',
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true
      }
    }
  }
})

export default {
  name: 'SearchObject',
  data () {
    return {
      objektPopoverItem: null,
      showSidebar: false,
      dragger: null,
      loading: false,
      loaded: 0,
      list: [],
      info: {},
      hits: 0,
      last: null,
      current: [],
      searchDone: false,
      selectedFilters: null,
      dropdowns: {
        auksjon: [],
        avdeling: [],
        objekttype: [],
        kategori: [],
        lokasjon: []
      },
      sort: 'Objektid',
      dir: 'DESC',

      filteredKunstner: [],
      filteredAuksjon: [],
      filteredKategori: [],
      filteredAvdeling: [],
      filteredObjekttype: [],
      filteredLokasjon: [],
      cachedAuksjonSearch: {},
      cachedKunstnerSearch: {},
      auctionSearching: false,
      kunstnerSearching: false,
      lastAuctionText: null,
      lastKunstnerText: null,
      photosUpdated: []
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')
    bus.$off('kunde-kontrakt-objekt-updated')
    bus.$off('close-object-search-popover')

    this.showSidebar = localStorage.getItem('obj-search-sidebar')

    bus.$off('advanced-objekt-search-start')
    bus.$off('advanced-objekt-search-clear-search')
    bus.$off('advanced-objekt-search-clear-filter')
    bus.$off('advanced-objekt-search-after-column-update')
    bus.$off('advanced-objekt-search-export')

    const q = sessionStorage.objectSearchQuery || null

    if (q) {
      this.$store.dispatch('objectsearch/saveQuery', q)
        .then(() => {
          // Load settings
          this.fetchSettings()

          sessionStorage.removeItem('objectSearchQuery')
        })
    } else {
      this.$store.dispatch('objectsearch/saveQuery', '')
        .then(() => {
          // Load settings
          this.fetchSettings()

          sessionStorage.removeItem('objectSearchQuery')
        })
    }
  },
  mounted () {
    bus.$on('advanced-objekt-search-start', (q) => this.onSearch(q))
    bus.$on('advanced-objekt-search-clear-search', () => this.onReset())
    bus.$on('advanced-objekt-search-clear-filter', () => this.onResetFilter())
    bus.$on('advanced-objekt-search-after-column-update', () => this.onAfterColumnUpdate())
    bus.$on('advanced-objekt-search-export', () => this.onExportResults())

    bus.$on('kunde-kontrakt-objekt-updated', (item) => this.onObjektUpdated(item))
    bus.$on('close-object-search-popover', () => {
      if (this.objektPopoverItem) {
        const vm = this
        setTimeout(function () {
          window.jQuery('#objekt-popover').removeClass('active')
          vm.objektPopoverItem = null
        }, 100)
      }
    })
  },
  beforeMount () {
    // Set some debounce on auction search, as it searches live...
    this.getFilteredAuksjonDebounced = this._.debounce(this.getFilteredAuksjonDebounced, 750)
    this.getFilteredKunstnerDebounced = this._.debounce(this.getFilteredKunstnerDebounced, 750)
  },
  watch: {
    loaded: function (newVal) {
      if (newVal && newVal === 5) {
        // If all settings loaded - reload filters, to maybe set dropdown values
        this.selectedFilters = this._.cloneDeep(this.filters) || {}

        if (this.query) {
          this.search()
        }
      }
    },
    'selectedFilters.avdeling': function (newVal) {
      if (newVal) {
        this.filteredAvdeling = this.dropdowns.avdeling.filter(x => {
          const found = this.selectedFilters.avdeling.find(s => {
            return s.val.toUpperCase() === x.val.toUpperCase()
          })

          return !found
        })
      } else {
        this.filteredAvdeling = this.dropdowns.avdeling
      }
    },
    'selectedFilters.lokasjon': function (newVal) {
      if (newVal) {
        this.filteredLokasjon = this.dropdowns.lokasjon.filter(x => {
          const found = this.selectedFilters.lokasjon.find(s => {
            return s.val.toUpperCase() === x.val.toUpperCase()
          })

          return !found
        })
      } else {
        this.filteredLokasjon = this.dropdowns.lokasjon
      }
    },
    'selectedFilters.kategori': function (newVal) {
      if (newVal) {
        this.filteredKategori = this.dropdowns.kategori.filter(x => {
          const found = this.selectedFilters.kategori.find(s => {
            return s.key.toUpperCase() === x.key.toUpperCase()
          })

          return !found
        })
      } else {
        this.filteredKategori = this.dropdowns.kategori
      }
    },
    'selectedFilters.objekttype': function (newVal) {
      if (newVal) {
        this.filteredObjekttype = this.dropdowns.objekttype.filter(x => {
          const found = this.selectedFilters.objekttype.find(s => {
            return s.key.toUpperCase() === x.key.toUpperCase()
          })

          return !found
        })
      } else {
        this.filteredObjekttype = this.dropdowns.objekttype
      }
    },
    'selectedFilters.auksjon': function (newVal) {
      if (newVal) {
        if (!this.lastAuctionText) {
          // No search string, remove selected ones from original list
          this.filteredAuksjon = this.dropdowns.auksjon.filter(x => {
            const found = this.selectedFilters.auksjon.find(s => {
              return s.key.toUpperCase() === x.key.toUpperCase()
            })

            return !found
          })
        } else {
          // Got a search string, remove seleted ones from current list
          this.filteredAuksjon = this.filteredAuksjon.filter(x => {
            const found = this.selectedFilters.auksjon.find(s => {
              return s.key.toUpperCase() === x.key.toUpperCase()
            })

            return !found
          })
        }
      } else {
        this.filteredAuksjon = this.dropdowns.auksjon
      }
    },
    'selectedFilters.kunstner': function (newVal) {
      if (newVal) {
        if (!this.lastKunstnerText) {
          // No search string, remove selected ones from original list
          this.filteredKunstner = []
        } else {
          // Got a search string, remove seleted ones from current list
          this.filteredKunstner = this.filteredKunstner.filter(x => {
            const found = this.selectedFilters.kunstner.find(s => {
              return s.val.toUpperCase() === x.val.toUpperCase()
            })

            return !found
          })
        }
      } else {
        this.filteredKunstner = []
      }
    }
  },
  computed: {
    query: function () {
      return this.$store.getters['objectsearch/query']
    },
    filters: function () {
      return this.$store.getters['objectsearch/filters']
    },
    columns: function () {
      // Should handle sorting
      const cols = this.$store.getters['objectsearch/columns']

      return cols.filter(c => c.selected)
    },
    columnKeys: function () {
      return this.columns.map((col) => {
        return col.key
      })
    },
    selectedImageSize: function () {
      return this.$store.getters['objectsearch/selectedImageSize']
    },
    sidebarVisibleClass: function () {
      return this.showSidebar ? 'minimizable' : 'minimized'
    }
  },
  methods: {
    onObjektUpdated: function (item) {
      const vm = this

      setTimeout(function () {
        vm.refetchItem(item)
      }, 1250)
    },
    refetchItem: function (item) {
      // Reload item in list...
      if (!item) {
        // No item
        return
      }

      const cindex = this.current.findIndex(o => o.Objektid === item.Objektid)

      // Not found...
      if (cindex === -1) {
        return
      }

      const findData = {
        search: {
          q: item.Objektnr,
          d: 'ASC',
          s: 'Objektid',
          f: null,
          l: 1
        }
      }

      NodeService.objekt(findData)
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            const updated = response.data.data.find(i => i.Objektid === item.Objektid)

            if (!updated) {
              return
            }

            this.rearrange([updated])
              .then(parsed => {
                if (parsed.list && parsed.list[0]) {
                  const lindex = this.list.findIndex(i => i.Objektid === item.Objektid)

                  if (lindex !== -1) {
                    // Update list
                    console.log('Update list', lindex, parsed.list[0])
                    this.$set(this.list, lindex, parsed.list[0])
                  }

                  // Update current
                  console.log('Update current', cindex, updated)
                  this.$set(this.current, cindex, updated)
                }
              })
          }
        })
        .catch(error => {
          console.log('Unable to find in ES - Dont do anything...')
          console.log(error)
        })
    },
    getFilteredKategori (text) {
      this.filteredKategori = this.dropdowns.kategori.filter((option) => {
        return option.key
          .toString()
          .toUpperCase()
          .indexOf(text.toUpperCase()) >= 0
      })
    },
    getFilteredObjekttype (text) {
      this.filteredObjekttype = this.dropdowns.objekttype.filter((option) => {
        return option.key
          .toString()
          .toUpperCase()
          .indexOf(text.toUpperCase()) >= 0
      })
    },
    getFilteredAvdeling (text) {
      this.filteredAvdeling = this.dropdowns.avdeling.filter((option) => {
        return option.val
          .toString()
          .toUpperCase()
          .startsWith(text.toUpperCase())
      })
    },
    getFilteredLokasjon (text) {
      this.filteredLokasjon = this.dropdowns.lokasjon.filter((option) => {
        return option.val
          .toString()
          .toUpperCase()
          .startsWith(text.toUpperCase())
      })
    },
    getFilteredKunstnerDebounced (text) {
      this.getFilteredKunstner(text)
    },
    getFilteredKunstner (text) {
      const key = text ? text.toUpperCase() : '__EMPTY__'

      this.lastKunstnerText = text

      if (this.cachedKunstnerSearch.hasOwnProperty(key)) {
        const found = this.cachedKunstnerSearch[key]

        // Remove already used codes
        if (this.selectedFilters.kunstner === null) {
          this.filteredKunstner = found
        } else {
          this.filteredKunstner = found.filter(x => {
            const found = this.selectedFilters.kunstner.find(s => {
              return s.key === x.key
            })

            return !found
          })
        }
      } else {
        this.kunstnerSearching = true

        // search(key)
        KunstnerService.search(key, 1)
          .then((response) => {
            const found = response.data.map(x => {
              return { key: x.Idnr, val: x.name_original, period: x.period_dates || '' }
            })

            this.cachedKunstnerSearch[key] = found

            // Remove already used codes
            if (this.selectedFilters.kunstner === null) {
              this.filteredKunstner = found
            } else {
              this.filteredKunstner = found.filter(x => {
                const found = this.selectedFilters.kunstner.find(s => {
                  return s.key === x.key
                })

                return !found
              })
            }
          })
          .catch((error) => {
            console.log('Error', error)
            this.filteredKunstner = []
          })
          .then(() => {
            this.kunstnerSearching = false
          })
      }
    },
    getFilteredAuksjonDebounced (text) {
      this.getFilteredAuksjon(text)
    },
    getFilteredAuksjon (text) {
      const key = text ? text.toUpperCase() : '__EMPTY__'

      this.lastAuctionText = text

      if (this.cachedAuksjonSearch.hasOwnProperty(key)) {
        const found = this.cachedAuksjonSearch[key]

        // Remove already used codes
        if (this.selectedFilters.auksjon === null) {
          this.filteredAuksjon = found
        } else {
          this.filteredAuksjon = found.filter(x => {
            const found = this.selectedFilters.auksjon.find(s => {
              return s.key.toUpperCase() === x.key.toUpperCase()
            })

            return !found
          })
        }
      } else {
        this.auctionSearching = true

        AuksjonService.search(key)
          .then((response) => {
            const found = response.data.map(x => {
              let val = x.Beskrivelse || ''
              if (x.Beskrivelse && x.Auksjon_dato) {
                val += ' (' + moment(x.Auksjon_dato).format('YYYY-MM-DD') + ')'
              }
              return { key: x.Auksjon, val: val }
            })

            this.cachedAuksjonSearch[key] = found

            // Remove already used codes
            if (this.selectedFilters.auksjon === null) {
              this.filteredAuksjon = found
            } else {
              this.filteredAuksjon = found.filter(x => {
                const found = this.selectedFilters.auksjon.find(s => {
                  return s.key.toUpperCase() === x.key.toUpperCase()
                })

                return !found
              })
            }
          })
          .catch((error) => {
            console.log('Error', error)
            this.filteredAuksjon = []
          })
          .then(() => {
            this.auctionSearching = false
          })
      }
    },
    onAuctionAdd: function (x) {
      // Reset last auction text
      const filtered = this.filteredAuksjon.filter(a => a.key.toUpperCase() !== x.key.toUpperCase())

      if (filtered.length <= 0) {
        this.lastAuctionText = null
      }
    },
    onAuctionDel: function (x) {
      // Reload list
      if (this.lastAuctionText) {
        this.getFilteredAuksjon(this.lastAuctionText)
      }
    },
    onKunstnerAdd: function (x) {
      // Reset last kunstner text
      const filtered = this.filteredKunstner.filter(a => a.key !== x.key)

      if (filtered.length <= 0) {
        this.lastKunstnerText = null
      }
    },
    onKunstnerDel: function (x) {
      // Reload list
      if (this.lastKunstnerText) {
        this.getFilteredKunstner(this.lastKunstnerText)
      }
    },
    onExportResults: function () {
      if (!this.current || !this.current.length) {
        this.$helpers.showErrorAlert('Feil', 'Fant ingen objekter å eksportere')
        return
      }

      this.rearrange(this.current)
        .then((parsed) => {
          // All export data
          const data = []

          const includeImage = this.selectedImageSize.key !== 'c-image-none'

          // Add headings
          const item = []

          item.push('#')
          this.columns.forEach(c => {
            if (c.key !== 'photo_thumb' || includeImage) {
              item.push(c.name)
            }
          })
          data.push(item)

          // Add values
          let counter = 0
          parsed.list.forEach(r => {
            const item = []
            item.push(++counter)

            r.row.forEach(c => {
              if (!c.image) {
                item.push(c.value)
              } else if (includeImage) {
                item.push((c.large || c.thumb) || '-')
              }
            })

            data.push(item)
          })

          // Make csv and force download...
          const csv = '\ufeff' + Papa.unparse(data, { delimiter: ';' })
          const blob = new Blob([csv], {
            type: 'application/csvcharset=utf-8'
          })

          fileDownload(blob, 'objektsok-' + moment().format('DDMMYYHms') + '.csv')
        })
        .catch(error => {
          console.log('*** CSV Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke eksportere')
        })
    },
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar

      if (this.showSidebar) {
        localStorage.setItem('obj-search-sidebar', 1)
      } else {
        localStorage.removeItem('obj-search-sidebar')
      }
    },
    scrollToTop: function () {
      window.jQuery('.table-results').scrollTop(0)
    },
    sortColumn: function (column, index) {
      if (!column.sortKey) {
        // Not sortable
        return
      }

      if (column.sortKey === this.sort) {
        this.dir = this.dir === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sort = column.sortKey
        this.dir = 'ASC'
      }

      this.search()
    },
    toggleObjektInfo (evt, Objektid) {
      if (this.objektPopoverItem) {
        window.jQuery('#objekt-popover').removeClass('active')
        this.objektPopoverItem = null
      } else if (this.info.hasOwnProperty(Objektid)) {
        // Setup item
        const item = this.info[Objektid]
        this.objektPopoverItem = item
        this.objektPopoverItem.objektLink = '/kunde/' + item.kontrakt.Kundenr + '?kontrakt=' + item.kontrakt.Kontraktnr + '&objekt=' + item.Objektid
        this.objektPopoverItem.kontraktLink = '/kunde/' + item.kontrakt.Kundenr + '?kontrakt=' + item.kontrakt.Kontraktnr
        this.objektPopoverItem.kundeLink = '/kunde/' + item.kontrakt.Kundenr
        this.objektPopoverItem.kjoperLink = item.mottaker ? '/kunde/' + item.mottaker.Kundenr : 'javascript:;'

        if (!this.objektPopoverItem.photo_large && !this.objektPopoverItem.photo_thumb) {
          this.objektPopoverItem.Photo = '/static/img/object.svg'
        } else if (this.objektPopoverItem.photo_large) {
          this.objektPopoverItem.Photo = this.objektPopoverItem.photo_large.startsWith('http')
            ? this.objektPopoverItem.photo_large
            : process.env.VUE_APP_AVANTI_API_URL + this.objektPopoverItem.photo_large
        } else if (this.objektPopoverItem.photo_thumb) {
          this.objektPopoverItem.Photo = this.objektPopoverItem.photo_thumb.startsWith('http')
            ? this.objektPopoverItem.photo_thumb
            : process.env.VUE_APP_AVANTI_API_URL + this.objektPopoverItem.photo_thumb
        }

        setTimeout(function () {
          const $offsetTop = window.jQuery(evt.target)[0].getBoundingClientRect().top + window.jQuery('.table-results')['scrollTop']()

          window.jQuery('#objekt-popover').css({
            top: $offsetTop - 38
          })

          window.jQuery('#objekt-popover').addClass('active')
        }, 50)
      }
    },
    openKunstnerObjektListModal: function (item) {
      if (item) {
        this.openModal('kunstner-objekt-list-modal', { kunstner: item, internalWindow: true }, 'large')
      }
    },
    openObjekt (Objektid) {
      if (this.objektPopoverItem) {
        window.jQuery('#objekt-popover').removeClass('active')
        this.objektPopoverItem = null
      } else if (this.info.hasOwnProperty(Objektid)) {
        // Remove the hover effect, when clicking on a row....
        window.jQuery('#hi-container').removeClass('active')
        window.jQuery(document).unbind('mousemove')

        this.loadObjektModal(Objektid)
      }
    },
    more () {
      this.search(this.last)
    },
    onAfterColumnUpdate: function () {
      this.rearrange(this.current)
        .then((parsed) => {
          this.list = parsed.list
          this.last = parsed.last
          this.info = parsed.info
        })
    },
    onSearch: function (data) {
      this.$store.dispatch('objectsearch/saveQuery', data.query || '')
        .then(() => {
          this.search()
        })
    },
    onReset: function () {
      this.$store.dispatch('objectsearch/saveQuery', '')
    },
    onResetFilter: function () {
      this.$store.dispatch('objectsearch/resetSearch', false)
        .then(() => {
          this.selectedFilters = this._.cloneDeep(this.filters)

          this.lastAuctionText = null
          this.lastKunstnerText = null
          this.info = {}
          this.list = []
          this.current = []
          this.hits = 0
          this.last = null

          // Redo search, without filters, if we have a query string
          if (this.query) {
            this.search()
          }
        })
    },
    search: function (from = null) {
      if (this.loading) {
        console.log('Already searching, so skip...')
        return
      }

      this.searchDone = false
      this.loading = true

      const postData = {
        search: {
          q: this.query || '',
          d: this.dir || 'DESC',
          s: this.sort || 'Objektid',
          f: null,
          l: from ? 250 : 250
        }
      }

      // Fallback, just in case - as seen in Sentry...
      if (this.selectedFilters === null || this.selectedFilters === undefined) {
        this.selectedFilters = {
          kategori: [],
          auksjon: [],
          kunstner: [],
          objekttype: null,
          auksjonSearchAll: 0,
          avdeling: [],
          lokasjon: [],
          regdato: {},
          price: {}
        }
      }

      let f = {}
      if (this.selectedFilters.kategori) {
        // Remove all stuff except the category code...
        this.selectedFilters.kategori = this.selectedFilters.kategori.map((x) => {
          return { key: x.key, val: x.val }
        })

        // And generate what's needed for the post
        f.kategori = this.selectedFilters.kategori.map((x) => {
          return x.key
        })
      }

      if (this.selectedFilters.kunstner) {
        f.kunstner = this.selectedFilters.kunstner

        // Remove all stuff except the category code...
        this.selectedFilters.kunstner = this.selectedFilters.kunstner.map((x) => {
          return { key: x.key, val: x.val }
        })

        // And generate what's needed for the post
        f.kunstner = this.selectedFilters.kunstner.map((x) => {
          return x.key
        })
      }

      if (this.selectedFilters.auksjon) {
        f.auksjon = this.selectedFilters.auksjon

        // Remove all stuff except the category code...
        this.selectedFilters.auksjon = this.selectedFilters.auksjon.map((x) => {
          return { key: x.key, val: x.val }
        })

        // And generate what's needed for the post
        f.auksjon = this.selectedFilters.auksjon.map((x) => {
          return x.key
        })
      }

      if (this.selectedFilters.auksjonSearchAll) {
        f.auksjonSearchAll = 1
      }

      if (this.selectedFilters.avdeling) {
        // Remove all stuff except the category code...
        this.selectedFilters.avdeling = this.selectedFilters.avdeling.map(x => {
          return { key: x.key, val: x.val }
        })

        // And generate what's needed for the post
        f.avdeling = this.selectedFilters.avdeling.map((x) => {
          return x.key
        })
      }

      if (this.selectedFilters.lokasjon) {
        // And generate what's needed for the post
        f.lokasjon = this.selectedFilters.lokasjon.map((x) => {
          return x.key
        })
      }

      if (this.selectedFilters.objekttype) {
        // Remove all stuff except the objekttype key...
        this.selectedFilters.objekttype = this.selectedFilters.objekttype.map((x) => {
          return { key: x.key, val: x.val }
        })

        // And generate what's needed for the post
        f.objekttype = this.selectedFilters.objekttype.map((x) => {
          return x.key
        })
      }

      if (this.selectedFilters.regdato && (this.selectedFilters.regdato.from || this.selectedFilters.regdato.to)) {
        f.regdato = {}

        if (this.selectedFilters.regdato.from) {
          f.regdato.from = moment(this.selectedFilters.regdato.from).format('YYYY-MM-DD')
        }

        if (this.selectedFilters.regdato.to) {
          f.regdato.to = moment(this.selectedFilters.regdato.to).format('YYYY-MM-DD')
        }
      }

      if (this.selectedFilters.price && (this.selectedFilters.price.from || this.selectedFilters.price.to)) {
        f.price = {}

        if (this.selectedFilters.price.from) {
          f.price.from = this.selectedFilters.price.from
        }

        if (this.selectedFilters.price.to) {
          f.price.to = this.selectedFilters.price.to
        }
      }

      if (f !== {}) {
        postData.search.f = f
      }

      if (from) {
        postData.search.a = from
      }

      const dispatchParams = { query: this.query, filters: this.selectedFilters }

      console.log('*** Search with:', dispatchParams)
      this.$store.dispatch('objectsearch/saveSearch', dispatchParams)
        .then(() => {
          this.selectedFilters = this._.cloneDeep(this.filters)
        })

      // For the old search, save query
      localStorage.searchQuery = this.query || ''

      console.log(postData)
      NodeService.objekt(postData)
        .then((response) => {
          // Store response list
          if (!from) {
            this.current = response.data.data
          } else {
            this.current = [...this.current, ...response.data.data]
          }

          this.rearrange(response.data.data)
            .then((parsed) => {
              if (!from) {
                this.list = parsed.list
              } else {
                this.list = [...this.list, ...parsed.list]
              }

              this.last = parsed.last
              this.info = parsed.info

              this.hits = response.data.hits

              bus.$emit('advanced-objekt-search-info', { hits: this.hits, sums: parsed.sums })
            })
        })
        .catch(error => {
          console.log('*** Search error')
          console.log(error)

          const message = this._.has(error, 'response.data.error')
            ? error.response.data.error
            : 'Noe gikk galt, prøv igjen.'

          this.$helpers.showErrorAlert('Feil', message)
        })
        .then(() => {
          this.loading = false
          this.searchDone = true
        })
    },
    rearrange: function (data = []) {
      return new Promise((resolve, reject) => {
        const defaultThumbnail = '/static/img/object.svg'

        const retval = {
          list: [],
          info: [],
          last: null,
          sums: 0
        }

        // Parse/format/sort data
        data.forEach(obj => {
          const row = []

          this.columns.forEach(c => {
            let val = this._.get(obj, c.key, c.default)
            let cls = c.class || ''

            if (c.filter && val !== c.default) {
              switch (c.filter) {
                case 'date':
                  val = this.$options.filters.avantidate(val)
                  break
                case 'datetime':
                  val = this.$options.filters.avantidatetime(val)
                  break
                case 'integer':
                  val = this.$options.filters.thousands(val)
                  break
                case 'decimal':
                  val = this.$options.filters.thousandsFloat(val)
                  break
              }
            }

            if (c.key === 'photo_thumb') {
              val = this._.get(obj, 'photos_fotoware', c.default)

              if (val.hasOwnProperty('thumb') && val['thumb'].length > 0) {
                // Thumbnail
                let thumb = val['thumb'][0]

                // Also find the large
                let large = (val.hasOwnProperty('large') && val['large'].length > 0) ? val['large'][0] : null

                // Add domain if needed
                if (thumb && !thumb.startsWith('http')) {
                  thumb = process.env.VUE_APP_AVANTI_API_URL + thumb
                }

                if (large && !large.startsWith('http')) {
                  large = process.env.VUE_APP_AVANTI_API_URL + large
                }

                row.push({ value: thumb, large: large, class: cls, tooltip: false, image: true })
              } else {
                row.push({ value: defaultThumbnail, large: null, class: cls, tooltip: false, image: true })
              }
            } else {
              row.push({ value: val, class: cls, tooltip: c.tooltip && val !== c.default ? this.$options.filters.truncate(val, 600) : false })
            }
          })

          retval.last = obj._sort
          retval.info[obj.Objektid] = obj
          retval.list.push({ Objektid: obj.Objektid, row: row })

          retval.sums += (obj.Vurderingspris2 ? obj.Vurderingspris2 : 0)
        })

        resolve(retval)
      })
    },
    fetchSettings: function () {
      /**
       * TODO: Fetch with promise all or one endpoint to get both
       */

      // Kategori
      InstillingerService('kategori').dropdown()
        .then((response) => {
          this.dropdowns.kategori = response.data

          this.filteredKategori = this._.cloneDeep(this.dropdowns.kategori)
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned kategori fra innstillinger')
        })
        .then(() => {
          ++this.loaded
        })

      // Auksjon
      AuksjonService.latestFifty()
        .then((response) => {
          const found = response.data.map(x => {
            let val = x.Beskrivelse || ''
            if (x.Auksjon_dato) {
              val += ' (' + moment(x.Auksjon_dato).format('YYYY-MM-DD') + ')'
            }
            return { key: x.Auksjon, val: val }
          })

          this.dropdowns.auksjon = found
          this.filteredAuksjon = found

          // And add this to cache
          this.cachedAuksjonSearch['__EMPTY__'] = found
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned auksjon fra innstillinger')
        })
        .then(() => {
          ++this.loaded
        })

      // Avdeling
      InstillingerService('avdeling').dropdown()
        .then((response) => {
          const found = response.data.map(x => {
            if (x.val.startsWith('Kunst')) {
              x.val = 'Kunst'
            } else if (x.val.startsWith('Nett')) {
              x.val = 'Nett'
            }

            return { key: x.key, val: x.val }
          })

          this.dropdowns.avdeling = found
          this.filteredAvdeling = found
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned avdeling fra innstillinger')
        })
        .then(() => {
          ++this.loaded
        })

      // Lokajson
      InstillingerService('lokasjon').dropdown('id')
        .then((response) => {
          const found = response.data.map(x => {
            return { key: x.key, val: x.val }
          })

          this.dropdowns.lokasjon = found
          this.filteredLokasjon = found
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned lokasjon fra innstillinger')
        })
        .then(() => {
          ++this.loaded
        })

      // Objekttype
      InstillingerService('objekttype').dropdown()
        .then((response) => {
          this.dropdowns.objekttype = response.data

          this.filteredObjekttype = this._.cloneDeep(this.dropdowns.objekttype)
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned kontrakttype fra innstillinger')
        })
        .then(() => {
          ++this.loaded
        })
    }
  }
}
</script>

<style scoped>
td.c-options a {
  width: 31px;
}
td.c-options a:hover {
  background-color: #eaeaea;
}

.uppercase .input {
  text-transform: uppercase;
}

.nowrap {
  white-space: nowrap;
  word-break: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Search/SearchObject.vue